import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Category } from '~app/modules/generic/models';
import {
  PROMO_CATEGORIES_ID,
  TOP_MENU_PROMOTION_LINK_ID
} from '~app/modules/generic/constants/promo-constants';

@Component({
  selector: 'app-category-item',
  templateUrl: './category-item.component.html',
  styleUrls: ['./category-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryItemComponent {
  @Input() category: Category;
  @Input() iconName: string;
  @Input() isActive: boolean;
  @Output() categorySelected = new EventEmitter<Category>();
  public promoCategoryId = PROMO_CATEGORIES_ID;
  public topMenuPromotionLinkId = TOP_MENU_PROMOTION_LINK_ID;

  constructor() {}

  onCategorySelected(e: MouseEvent, category: Category) {
    e.stopPropagation();
    this.categorySelected.next(category);
  }
}
